import { useMemo } from 'react';
import { SiteConfigManager, useSettings, useSportState } from '@atlas/core';

const useSelectedMarketType = () => {
  const { id, mainMarketTypes } = useSportState();

  const { sportMarketTypes } = useSettings();
  const sportMarketTypesSettings = useMemo(
    () => JSON.parse(sportMarketTypes || '{}'),
    [sportMarketTypes],
  );
  const mainMarketsChoice = SiteConfigManager.getConfig(
    'config.config.sportsbook.mainMarketsChoice',
  );
  const simplifiedView = SiteConfigManager.getConfig('config.config.sportsbook.mobileGridViewType');

  const firstAvailableMarketType = useMemo(
    () =>
      mainMarketTypes &&
      mainMarketTypes.sort((a, b) => a.orderPosition - b.orderPosition)[0]?.id.toString(),
    [mainMarketTypes],
  );

  return useMemo(() => {
    const selectedMarketType = sportMarketTypesSettings[id]?.[0];

    if (simplifiedView === 'simplified') {
      return selectedMarketType || firstAvailableMarketType;
    }

    if (mainMarketsChoice && selectedMarketType) {
      return selectedMarketType;
    }
  }, [id, mainMarketsChoice, sportMarketTypesSettings]);
};

export default useSelectedMarketType;
